module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.user) ? _c('div', [_c('button', {
    staticClass: "btn btn-link",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-back"
  }), _c('span', [_vm._v("Back")])]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), (_vm.user) ? _c('div', [_c('ul', {
    staticClass: "tab"
  }, [_c('li', {
    staticClass: "tab-item"
  }, [_c('a', {
    class: {
      active: _vm.tab === 0
    },
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.tab = 0
      }
    }
  }, [_vm._v("Profile")])]), _vm._v(" "), (_vm.isClient) ? _c('li', {
    staticClass: "tab-item"
  }, [_c('a', {
    class: {
      active: _vm.tab === 1
    },
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.tab = 1
      }
    }
  }, [_vm._v("Matters")])]) : _vm._e(), _vm._v(" "), (_vm.isClient) ? _c('li', {
    staticClass: "tab-item"
  }, [_c('a', {
    class: {
      active: _vm.tab === 2
    },
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.tab = 2
      }
    }
  }, [_vm._v("VEVO")])]) : _vm._e()]), _vm._v(" "), (_vm.tab === 0) ? _c('userProfile', {
    attrs: {
      "user": _vm.user
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tab === 1) ? _c('clientMatters', {
    attrs: {
      "user": _vm.user
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tab === 2) ? _c('clientVevo', {
    attrs: {
      "user": _vm.user
    }
  }) : _vm._e()], 1) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c8654e9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/users/user.vue
// module id = 492
// module chunks = 1